<script lang="ts">
    export let client: any;
</script>

<h3 class="text-base mb-2">SOCIAL MEDIA</h3>
<div class="text-sm text-white flex flex-col gap-2">
    {#each client?.social_media as sosmed}
        {#if sosmed?.social_media_name === "instagram"}
            <a
                target="_blank"
                class="no-underline hover:no-underline w-full"
                href={sosmed?.link}
            >
                <button
                    class="px-4 flex flex-row items-center text-white w-full justify-between py-3 rounded-md transition-all bg-[#0766FF] hover:bg-[#0766FF]/90"
                >
                    <span class="flex flex-row gap-2 items-center">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g id="ri:instagram-fill">
                                <path
                                    id="Vector"
                                    d="M10.8566 1.66663C11.7941 1.66913 12.27 1.67413 12.6808 1.68579L12.8425 1.69163C13.0291 1.69829 13.2133 1.70663 13.4358 1.71663C14.3225 1.75829 14.9275 1.89829 15.4583 2.10413C16.0083 2.31579 16.4716 2.60246 16.935 3.06496C17.3587 3.48154 17.6866 3.98545 17.8958 4.54163C18.1016 5.07246 18.2416 5.67746 18.2833 6.56496C18.2933 6.78663 18.3016 6.97079 18.3083 7.15829L18.3133 7.31996C18.3258 7.72996 18.3308 8.20579 18.3325 9.14329L18.3333 9.76496V10.8566C18.3353 11.4645 18.3289 12.0723 18.3141 12.68L18.3091 12.8416C18.3025 13.0291 18.2941 13.2133 18.2841 13.435C18.2425 14.3225 18.1008 14.9266 17.8958 15.4583C17.6872 16.0148 17.3592 16.5188 16.935 16.935C16.5183 17.3586 16.0144 17.6864 15.4583 17.8958C14.9275 18.1016 14.3225 18.2416 13.4358 18.2833C13.238 18.2926 13.0403 18.3009 12.8425 18.3083L12.6808 18.3133C12.27 18.325 11.7941 18.3308 10.8566 18.3325L10.235 18.3333H9.14412C8.536 18.3354 7.92789 18.329 7.31995 18.3141L7.15829 18.3091C6.96046 18.3016 6.76268 18.293 6.56495 18.2833C5.67829 18.2416 5.07329 18.1016 4.54162 17.8958C3.98551 17.6869 3.4818 17.359 3.06579 16.935C2.64166 16.5185 2.31347 16.0146 2.10412 15.4583C1.89829 14.9275 1.75829 14.3225 1.71662 13.435C1.70733 13.2372 1.699 13.0394 1.69162 12.8416L1.68745 12.68C1.6721 12.0723 1.66515 11.4645 1.66662 10.8566V9.14329C1.66429 8.53546 1.6704 7.92762 1.68495 7.31996L1.69079 7.15829C1.69745 6.97079 1.70579 6.78663 1.71579 6.56496C1.75745 5.67746 1.89745 5.07329 2.10329 4.54163C2.31255 3.98488 2.64139 3.48081 3.06662 3.06496C3.48253 2.64119 3.98591 2.31328 4.54162 2.10413C5.07329 1.89829 5.67745 1.75829 6.56495 1.71663C6.78662 1.70663 6.97162 1.69829 7.15829 1.69163L7.31995 1.68663C7.92761 1.67182 8.53545 1.66543 9.14329 1.66746L10.8566 1.66663ZM9.99995 5.83329C8.89488 5.83329 7.83508 6.27228 7.05367 7.05368C6.27227 7.83508 5.83329 8.89489 5.83329 9.99996C5.83329 11.105 6.27227 12.1648 7.05367 12.9462C7.83508 13.7276 8.89488 14.1666 9.99995 14.1666C11.105 14.1666 12.1648 13.7276 12.9462 12.9462C13.7276 12.1648 14.1666 11.105 14.1666 9.99996C14.1666 8.89489 13.7276 7.83508 12.9462 7.05368C12.1648 6.27228 11.105 5.83329 9.99995 5.83329ZM9.99995 7.49996C10.3283 7.4999 10.6534 7.56452 10.9567 7.6901C11.26 7.81569 11.5357 7.99979 11.7678 8.2319C12 8.46401 12.1842 8.73957 12.3099 9.04287C12.4356 9.34616 12.5003 9.67124 12.5004 9.99954C12.5004 10.3278 12.4358 10.6529 12.3102 10.9563C12.1846 11.2596 12.0005 11.5352 11.7684 11.7674C11.5363 11.9996 11.2608 12.1838 10.9575 12.3095C10.6542 12.4352 10.3291 12.4999 10.0008 12.5C9.33774 12.5 8.70186 12.2366 8.23302 11.7677C7.76418 11.2989 7.50079 10.663 7.50079 9.99996C7.50079 9.33692 7.76418 8.70103 8.23302 8.23219C8.70186 7.76335 9.33774 7.49996 10.0008 7.49996M14.3758 4.58329C14.0995 4.58329 13.8346 4.69304 13.6392 4.88839C13.4439 5.08374 13.3341 5.34869 13.3341 5.62496C13.3341 5.90123 13.4439 6.16618 13.6392 6.36153C13.8346 6.55688 14.0995 6.66663 14.3758 6.66663C14.6521 6.66663 14.917 6.55688 15.1124 6.36153C15.3077 6.16618 15.4175 5.90123 15.4175 5.62496C15.4175 5.34869 15.3077 5.08374 15.1124 4.88839C14.917 4.69304 14.6521 4.58329 14.3758 4.58329Z"
                                    fill="#FAFAFA"
                                />
                            </g>
                        </svg>
                        <span> INSTAGRAM </span>
                    </span>
                    <span>FOLLOW</span>
                </button>
            </a>
        {/if}
        {#if sosmed?.social_media_name === "facebook"}
            <a
                target="_blank"
                class="no-underline hover:no-underline w-full"
                href={sosmed?.link}
            >
                <button
                    class="px-4 flex flex-row items-center text-white w-full justify-between py-3 rounded-md transition-all bg-[#E03567] hover:bg-[#E03567]/90"
                >
                    <span class="flex flex-row gap-2 items-center">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g id="ri:facebook-circle-fill">
                                <path
                                    id="Vector"
                                    d="M10.0008 1.66663C5.39831 1.66663 1.66748 5.39746 1.66748 9.99996C1.66748 14.1591 4.71498 17.6066 8.69915 18.2316V12.4091H6.58248V9.99996H8.69915V8.16413C8.69915 6.07579 9.94248 4.92246 11.8466 4.92246C12.7583 4.92246 13.7116 5.08496 13.7116 5.08496V7.13496H12.6616C11.6258 7.13496 11.3033 7.77746 11.3033 8.43663V9.99996H13.6141L13.245 12.4083H11.3033V18.2316C15.2866 17.6075 18.3333 14.16 18.3333 9.99996C18.3333 5.39746 14.6033 1.66663 10.0008 1.66663Z"
                                    fill="#FAFAFA"
                                />
                            </g>
                        </svg>
                        <span>FACEBOOK</span>
                    </span>
                    <span>LIKE</span>
                </button>
            </a>
        {/if}
        {#if sosmed?.social_media_name === "twitter"}
            <a
                target="_blank"
                class="no-underline hover:no-underline w-full"
                href={sosmed?.link}
            >
                <button
                    class="px-4 flex flex-row items-center text-white w-full justify-between py-3 rounded-md transition-all bg-[#000000] hover:bg-[#000000]/90"
                >
                    <span class="flex flex-row gap-2 items-center">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g id="ri:twitter-x-fill">
                                <path
                                    id="Vector"
                                    d="M15.1708 1.875H17.9275L11.905 8.75833L18.99 18.125H13.4416L9.09662 12.4442L4.12495 18.125H1.36662L7.80828 10.7625L1.01245 1.875H6.69995L10.6275 7.0675L15.1708 1.875ZM14.2033 16.475H15.7308L5.87078 3.43833H4.23162L14.2033 16.475Z"
                                    fill="#FAFAFA"
                                />
                            </g>
                        </svg>
                        <span>TWITTER</span>
                    </span>
                    <span>FOLLOW</span>
                </button>
            </a>
        {/if}
    {/each}
</div>
